import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { Link } from "react-router-dom";
import driveBetter from "../../../assets/images/v3/drive_better.svg";
import Spinner from "react-bootstrap/Spinner";
import flag from "../../../assets/images/v3/icons/color_bar.svg";
import moment from "moment";

var formatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
});

const Renewal = ({ quoteBuilder = false, customerName, orderHashId }) => {
	const [drivers, setDrivers] = useState([]);
	const [cars, setCars] = useState([]);
	const [amount, setAmount] = useState([]);

	const renewalData = useSelector((state) => state.RenewalData);
	const renewalId = useSelector((state) => state.RenewalId);
	const loading = useSelector((state) => state.LoadingPage);

	const dispatch = useDispatch();

	/* 	useEffect(() => {
		if (renewalId) {
			fetch(`/api/v2/quotes/${renewalId}`)
				.then((res) => res.json())
				.then((res) => {
					dispatch({
						type: "SET_INITIAL_QUOTE_DATA",
						payload: res.quote,
					});
				});
		}
	}, [renewalId]); */

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		if (renewalData) {
			setAmount(renewalData.amount);
			setDrivers(renewalData.drivers);
			setCars(renewalData.cars);
		}
	}, [renewalData]);

	const getLiabilityPrice = (amount) => {
		if (amount && amount.products && amount.products.length > 0) {
			const liabilityProduct = amount.products.find(
				(product) => product.id === 3 || product.id === 4
			);
			return formatter.format(_.get(liabilityProduct, `price`, ""));
		}
	};

	const getPhysicalPrice = (amount) => {
		if (amount && amount.products && amount.products.length > 0) {
			const physicalProduct = amount.products.find(
				(product) => product.id === 1 || product.id === 2
			);
			return formatter.format(_.get(physicalProduct, `price`, ""));
		}
	};

	return (
		<>
			{loading ? (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						paddingTop: "24px",
					}}
				>
					<Spinner
						animation="border"
						style={{ height: "4rem", width: "4rem" }}
					/>
				</div>
			) : (
				<>
					<div className="renewal general container">
						<div className="otmb-4">
							<div className="col-12 col-lg-12 column1">
								<div className="row justify-content-lg-center otmt-4">
									{!quoteBuilder ? (
										<h1 className="col-12 pl-lg-0" style={{ color: "#00788A" }}>
											Renew My Coverage
										</h1>
									) : (
										<h1 className="col-12 pl-lg-0" style={{ color: "#00788A" }}>
											{customerName} Coverage Quote
										</h1>
									)}
								</div>
							</div>
							<div className="col col-lg-7 column2 pl-lg-0 otmb-4">
								<h4 className="col-12 pl-0 otmt-4" style={{ color: "#979797" }}>
									Coverage Summary
								</h4>
								<div className="heading">
									<div className="desc"></div>
								</div>
								<div className="row justify-content-lg-center">
									<div className="col col-lg-12 otmt-4">
										<div className="card">
											<div className="card-body">
												<div className="row justify-content-center">
													<h3 className="col-11 col-lg-11 pl-lg-0 otmt-1">
														Physical Damage Protection
													</h3>
													<div className="col-11 pl-lg-0 d-md-flex">
														<div className="d-flex">
															<p className="font-weight-bold text-uppercase">
																Starts:
															</p>
															<p className="ml-1">
																{moment(renewalData.policy_start).format(
																	"MM-DD-YYYY"
																)}{" "}
																at 12:01am
															</p>
														</div>
														<div className="d-flex">
															<p className="ml-md-4 font-weight-bold text-uppercase">
																Ends:
															</p>
															<p className="ml-1">
																{moment(renewalData.policy_end).format(
																	"MM-DD-YYYY"
																)}{" "}
																at 12:01am
															</p>
														</div>
													</div>
													<div className="col-11 pl-lg-0 d-flex">
														<p className="text-uppercase font-weight-bold">
															Drivers:
														</p>

														<p className="ml-lg-2">
															{drivers
																.map(
																	(driver, i) =>
																		`${driver.first_name} ${driver.last_name}`
																)
																.join(", ")}
														</p>
													</div>
												</div>
												<div className="justify-content-lg-start ml-1 ml-lg-3 row">
													{cars.map((car, i) => (
														<div
															className="car-card col-11 col-lg-10 pl-0 pr-0 ml-2 ml-lg-0 otmt-1"
															key={i}
														>
															<h3
																className="col-12 ml-1 otmt-2"
																style={{ color: "#00788A" }}
															>
																{car.year} {car.make} {car.car_model}
															</h3>
															<div className="align-items-baseline d-flex ml-4">
																<p className="mb-0 text-uppercase font-weight-bold">
																	COVERAGE VALUE:{" "}
																</p>
																<p className="ml-1 mb-0">
																	{formatter.format(car.value)}
																</p>
															</div>
															<div className="align-items-baseline d-flex ml-4 otmb-2">
																<p className="mb-0 text-uppercase font-weight-bold">
																	DEDUCTIBLE:{" "}
																</p>
																<p className="ml-1">
																	{formatter.format(
																		(car.value * car.deductible_percentage) /
																			100
																	)}{" "}
																	({Math.round(car.deductible_percentage)}%)
																</p>
															</div>
														</div>
													))}
												</div>

												{_.get(renewalData, `liability_coverage`) ? (
													<div className="row">
														<div className="col-12 d-lg-flex flex-lg-wrap">
															<hr className="col-11 otmt-2 otmb-2" />
															<h3 className="col-11">Liability Protection</h3>
															<div className="col">
																<div className="d-flex">
																	<p className="text-uppercase font-weight-bold mb-0">
																		Coverage Value:{" "}
																	</p>
																	<p className="ml-1 mb-0">
																		{formatter.format(
																			String(
																				_.get(
																					renewalData,
																					`liability_coverage`,
																					0
																				)
																			)
																		)}
																	</p>
																</div>
																<div className="d-flex">
																	<p className="text-uppercase font-weight-bold">
																		Deductible:{" "}
																	</p>
																	<p className="ml-1">
																		{formatter.format(2500)}
																	</p>
																</div>
															</div>
														</div>
													</div>
												) : null}

												{_.get(renewalData, `covers_misc_damage`) ? (
													<div className="row">
														<div className="col-12 d-lg-flex flex-lg-wrap">
															<hr className="col-11 otmt-2 otmb-2" />
															<h3 className="col-11">
																Misc Property Protection
															</h3>
															<div className="col">
																<div className="d-flex">
																	<p className="text-uppercase font-weight-bold mb-0">
																		Coverage Value:{" "}
																	</p>
																	<p className="ml-1 mb-0">$1,000,000.00</p>
																</div>
																<div className="d-flex">
																	<p className="text-uppercase font-weight-bold">
																		Deductible:{" "}
																	</p>
																	<p className="ml-1">
																		{formatter.format(2500)}
																	</p>
																</div>
															</div>
														</div>
													</div>
												) : null}

												<div className="row">
													<div className="col-12 d-lg-flex flex-lg-wrap">
														<hr className="col-11 otmt-2 otmb-2" />
														<div className="d-lg-flex ml-4">
															<img
																className="drivebetter mt-2"
																src={driveBetter}
																alt="..."
															/>
															<h3 className="">Program Subscription</h3>
														</div>
														<p className="col-11">
															Exclusive access to webinars, track guides &
															training content
														</p>
														<p className="col-11 otmb-4">
															Included with annual coverage
														</p>
														{!quoteBuilder ? (
															<Link
																to={`/v3/renewals/${renewalId}/react/edit`}
																className="col-lg-12 d-lg-flex justify-content-lg-center otmb-1"
																style={{ textDecoration: "none" }}
															>
																<button
																	type="button"
																	className="btn btn1 col-11 col-lg-9 mx-lg-auto"
																	onClick={() =>
																		dispatch({
																			type: "SET_DEFAULT_DATA",
																			payload: renewalData,
																		})
																	}
																>
																	ADD OR EDIT COVERAGE
																</button>
															</Link>
														) : null}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								{!quoteBuilder ? (
									<>
										<div className="row justify-content-lg-center">
											{!_.get(renewalData, `liability_coverage`, false) && (
												<>
													<hr className="softline l1 col-lg-11 otmt-2 otmb-2" />
													<div className="col-12 ">
														<h3 className="col-12" style={{ color: "#00788A" }}>
															Get liability protection
														</h3>
														<p className="col-12">
															Liability provides financial protection if you
															harm someone else or their property; including
															track property.
														</p>
														<div className="col-12 otmt-2">
															<Link
																to={`/v3/renewals/${renewalId}/react/liability`}
																className="col-12 col-lg-7 d-lg-flex justify-content-lg-center pl-lg-0"
																style={{ textDecoration: "none" }}
															>
																<button
																	type="button"
																	className="btn btn1 col-11 col-lg-12 mx-auto"
																>
																	ADD COVERAGE
																</button>
															</Link>
														</div>
													</div>
												</>
											)}

											{!_.get(renewalData, `covers_misc_damage`, false) && (
												<>
													<hr className="softline l1 col-lg-11 otmt-2 otmb-2" />
													<div className="col-12">
														<h3 className="col-12" style={{ color: "#00788A" }}>
															Cover your property at the track
														</h3>
														<p className="col-12">
															Adds $25,000 of Miscellaneous Property Coverage
															for additional $41.67 + taxes per month
														</p>
														<div className="col-12 otmt-2">
															<Link
																to={`/v3/renewals/${renewalId}/react/property`}
																className="col-12 col-lg-7 d-lg-flex justify-content-lg-center pl-lg-0"
																style={{ textDecoration: "none" }}
															>
																<button
																	type="button"
																	className="btn btn1 col-11 col-lg-12 mx-auto"
																>
																	ADD COVERAGE
																</button>
															</Link>
														</div>
													</div>
												</>
											)}
										</div>
									</>
								) : null}
							</div>
						</div>
						<div className="col col-lg-5 column3 pr-lg-0">
							<div className="row">
								<h4 className="col-11 otmt-4" style={{ color: "#979797" }}>
									Order Summary
								</h4>
								<div className="heading2">
									<div className="desc"></div>
								</div>
								<div className="align-items-center d-flex justify-content-between px-4 otmt-2">
									<p className="font-weight-bold mb-2">
										Physical Damage Protection
									</p>
									<h3 className="">{getPhysicalPrice(amount)}</h3>
								</div>
								<div className="align-items-center d-flex justify-content-between px-4">
									{_.get(renewalData, `liability_coverage`, false) ? (
										<>
											<p className=" font-weight-bold mb-2">
												Liability Protection
											</p>

											<h3 className="">{getLiabilityPrice(amount)}</h3>
										</>
									) : null}
								</div>
								<hr className="detail-line col-11 otmt-2 otmb-2" />
								<div className="align-items-center d-flex justify-content-between px-4">
									<p className="text-uppercase  font-weight-bold mb-2">
										premium subtotal
									</p>
									<h3 className="">
										{formatter.format(_.get(amount, `premium`, ""))}
									</h3>
								</div>
								<div className="align-items-center d-flex justify-content-between px-4">
									<p className="text-uppercase font-weight-bold mb-2">
										pay in full discount
									</p>
									<h3 className="" style={{ color: "#cf0207" }}>
										–{" "}
										{formatter.format(
											Math.round(
												(_.get(amount, `discount`, "") + Number.EPSILON) * 100
											) / 100
										)}
									</h3>
								</div>
								<div className="align-items-center d-flex justify-content-between px-4">
									<p className=" font-weight-bold mb-2">
										OpenTrack Drive Better Subscription
										<p className="">(Included w/ annual package)</p>
									</p>

									<h3 className="text-uppercase">Free</h3>
								</div>
								<div className="align-items-center d-flex justify-content-between px-4">
									<p className=" font-weight-bold mb-2">Fees & Taxes</p>
									<h3 className="">
										{formatter.format(_.get(amount, `taxes_discount`, ""))}
									</h3>
								</div>
								<hr className="detail-line col-11 otmt-2 otmb-2" />
								{/* 	<div className="align-items-center d-flex justify-content-between px-4">
									<p
										className="text-uppercase  font-weight-bold mb-2"
										style={{ color: "#00778A" }}
									>
										yearly total
									</p>
									<h3 className="">
										{formatter.format(_.get(amount, `total`, ""))}
									</h3>
								</div> */}

								{renewalData.referral_available ? (
									<div className="align-items-center d-flex justify-content-between px-4">
										<p className="text-uppercase font-weight-bold mb-2">
											pay in full discount
										</p>
										<h3 className="" style={{ color: "#cf0207" }}>
											–{" "}
											{formatter.format(
												Math.round(
													(_.get(amount, `discount`, "0") + Number.EPSILON) *
														100
												) / 100
											)}
										</h3>
									</div>
								) : null}
								{/* <hr className="detail-line col-11 otmt-2 otmb-2" /> */}
								<div className="align-items-center d-flex justify-content-between px-4">
									<p
										className="text-uppercase  font-weight-bold mb-2"
										style={{ color: "#00778a" }}
									>
										total
									</p>
									<h3 className="" style={{ color: "#00778a" }}>
										{renewalData.referral_available
											? formatter.format(
													_.get(amount, `total_referral_10_discount`, "")
											  )
											: formatter.format(
													_.get(amount, `annual_with_discount`, "")
											  )}
									</h3>
								</div>
							</div>
							<div className="row">
								<div className="col-12 otmt-4">
									<div className="card">
										<div>
											<h3
												className="col-12 text-center otmt-2"
												style={{ color: "#00778a" }}
											>
												Monthly Cost
											</h3>
											<h1 className="text-center" style={{ color: "#00778a" }}>
												{renewalData.referral_available
													? formatter.format(
															_.get(
																amount,
																`total_referral_10_discount_monthly_estimate`,
																""
															)
													  )
													: formatter.format(
															_.get(
																amount,
																`annual_with_discount_monthly_estimate`,
																""
															)
													  )}
											</h1>
											<p className="text-center">when billed yearly</p>
											<div>
												{!quoteBuilder ? (
													<Link
														to={`/v3/renewals/${renewalId}/react/checkout`}
														className="d-flex justify-content-center otmb-3 otmt-1"
														style={{ textDecoration: "none" }}
													>
														<button
															type="button"
															className="btn btn2 btn-lg col-10 col-lg-10 px-0"
														>
															PROCEED TO PAYMENT
														</button>
													</Link>
												) : (
													<Link
														to={`/v3/custom_quote/${orderHashId}/checkout`}
														className="d-flex justify-content-center otmb-3 otmt-1"
														style={{ textDecoration: "none" }}
													>
														<button
															type="button"
															className="btn btn2 btn-lg col-10 col-lg-10 px-0"
														>
															PROCEED TO PAYMENT
														</button>
													</Link>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default Renewal;
